import {
  DorAddAction,
  DorAddPayload,
  DorRemoveAction,
  DorRemovePayload,
  EtasjerUpdateAction,
  EtasjerUpdatePayload,
  EtasjerVeggsoneAddAction,
  EtasjerVeggsoneAddPayload,
  EtasjerVeggsoneUpdateAction,
  EtasjerVeggsoneUpdatePayload,
  EtasjeUpdateAction,
  EtasjeUpdatePayload,
  EtasjeVeggsoneAddAction,
  EtasjeVeggsoneAddPayload,
  EtasjeVeggsoneRemoveAction,
  EtasjeVeggsoneRemovePayload,
  EtasjeVeggsoneUpdateAction,
  EtasjeVeggsoneUpdatePayload,
  GulvSetHasMultipleZonesAction,
  GulvSetHasMultipleZonesPayload,
  GulvsoneAddAction,
  GulvsoneAddPayload,
  GulvsoneInitAction,
  GulvsoneRemoveAction,
  GulvsoneRemovePayload,
  GulvsoneUpdateAction,
  GulvsoneUpdatePayload,
  InitRegistrationAction,
  InitSoknadAction,
  RegistrationAction,
  TakUpdateAction,
  TakUpdatePayload,
  TakVinduAddAction,
  TakVinduAddPayload,
  TakVinduEditAction,
  TakVinduEditPayload,
  TakVinduRemoveAction,
  TakVinduRemovePayload,
  ToggleAllFloorsSameShapeAction,
  ToggleAllFloorsSameShapePayload,
  ToggleAllFloorsSameWallConstrAction,
  ToggleAllFloorsSameWallConstrPayload,
  ToggleAllWallsAgainstTheOpenAction,
  ToggleAllWallsAgainstTheOpenPayload,
  UpdateBygningsdetaljerAction,
  UpdateBygningsdetaljerPayload,
  UpdateCalculatedAreaAction,
  UpdateCalculatedAreaPayload,
  UpdateDetailingStepsAction,
  UpdateDetailingStepsPayload,
  UpdateEnergibrukAction,
  UpdateEnergibrukPayload,
  UpdateEnergibrukUnitAction,
  UpdateEnergibrukUnitPayload,
  UpdateKonstruksjonstetthetAction,
  UpdateKonstruksjonstetthetPayload,
  UpdateParametersAction,
  UpdateParametersPayload,
  UpdateRegistrationAction,
  UpdateRegistrationFieldAction,
  UpdateRegistrationFieldPayload,
  UpdateRegistrationPayload,
  UpdateTerrengskjermingAction,
  UpdateTerrengskjermingPayload,
  VinduAddAction,
  VinduAddPayload,
  VinduEditAction,
  VinduEditPayload,
  VinduRemoveAction,
  VinduRemovePayload,
  WallHasNoWindowsAction,
  WallHasNoWindowsPayload
} from './types';

export const updateRegistration = (payload: UpdateRegistrationPayload): UpdateRegistrationAction => ({
  payload,
  type: RegistrationAction.UPDATE_REGISTRATION
});

// INIT ACTION
export const initRegistration = (): InitRegistrationAction => ({
  type: RegistrationAction.INIT_REGISTRATION
});

// INIT SØKNAD ACTION
export const initSoknad = (): InitSoknadAction => ({
  type: RegistrationAction.INIT_SOKNAD
});

// DOR ACTIONS
export const addDor = (payload: DorAddPayload): DorAddAction => ({
  payload,
  type: RegistrationAction.DOR_ADD
});

export const removeDor = (payload: DorRemovePayload): DorRemoveAction => ({
  payload,
  type: RegistrationAction.DOR_REMOVE
});

// VINDU ACTIONS
export const addVindu = (payload: VinduAddPayload): VinduAddAction => ({
  payload,
  type: RegistrationAction.VINDU_ADD
});

export const removeVindu = (payload: VinduRemovePayload): VinduRemoveAction => ({
  payload,
  type: RegistrationAction.VINDU_REMOVE
});

export const editVindu = (payload: VinduEditPayload): VinduEditAction => ({
  payload,
  type: RegistrationAction.VINDU_EDIT
});

// GULVSONE ACTIONS
export const initGulvsoner = (): GulvsoneInitAction => ({
  type: RegistrationAction.GULVSONE_INIT
});

export const addGulvsone = (payload: GulvsoneAddPayload): GulvsoneAddAction => ({
  payload,
  type: RegistrationAction.GULVSONE_ADD
});

export const setHasMultipleZonesGulvsoner = (
  payload: GulvSetHasMultipleZonesPayload
): GulvSetHasMultipleZonesAction => ({
  payload,
  type: RegistrationAction.GULV_SET_HAS_MULTIPLE_ZONES
});

export const removeGulvsone = (payload: GulvsoneRemovePayload): GulvsoneRemoveAction => ({
  payload,
  type: RegistrationAction.GULVSONE_REMOVE
});

export const updateGulvsone = (payload: GulvsoneUpdatePayload): GulvsoneUpdateAction => ({
  payload,
  type: RegistrationAction.GULVSONE_UPDATE
});

// ETASJE ACTIONS
export const updateEtasje = (payload: EtasjeUpdatePayload): EtasjeUpdateAction => ({
  payload,
  type: RegistrationAction.ETASJE_UPDATE
});

export const setWallHasNoWindows = (payload: WallHasNoWindowsPayload): WallHasNoWindowsAction => ({
  payload,
  type: RegistrationAction.WALL_HAS_NO_WINDOWS
});

export const addEtasjeVeggsone = (payload: EtasjeVeggsoneAddPayload): EtasjeVeggsoneAddAction => ({
  payload,
  type: RegistrationAction.ETASJE_VEGGSONE_ADD
});

export const removeEtasjeVeggsone = (payload: EtasjeVeggsoneRemovePayload): EtasjeVeggsoneRemoveAction => ({
  payload,
  type: RegistrationAction.ETASJE_VEGGSONE_REMOVE
});

export const updateEtasjeVeggsone = (payload: EtasjeVeggsoneUpdatePayload): EtasjeVeggsoneUpdateAction => ({
  payload,
  type: RegistrationAction.ETASJE_VEGGSONE_UPDATE
});

// ETASJER ACTIONS
export const updateEtasjer = (payload: EtasjerUpdatePayload): EtasjerUpdateAction => ({
  payload,
  type: RegistrationAction.ETASJER_UPDATE
});

export const addEtasjerVeggsone = (payload: EtasjerVeggsoneAddPayload): EtasjerVeggsoneAddAction => ({
  payload,
  type: RegistrationAction.ETASJER_VEGGSONE_ADD
});

export const updateEtasjerVeggsone = (payload: EtasjerVeggsoneUpdatePayload): EtasjerVeggsoneUpdateAction => ({
  payload,
  type: RegistrationAction.ETASJER_VEGGSONE_UPDATE
});

// TAK ACTIONS
export const updateTak = (payload: TakUpdatePayload): TakUpdateAction => ({
  payload,
  type: RegistrationAction.TAK_UPDATE
});

export const addTakVindu = (payload: TakVinduAddPayload): TakVinduAddAction => ({
  payload,
  type: RegistrationAction.TAK_VINDU_ADD
});

export const editTakVindu = (payload: TakVinduEditPayload): TakVinduEditAction => ({
  payload,
  type: RegistrationAction.TAK_VINDU_EDIT
});

export const removeTakVindu = (payload: TakVinduRemovePayload): TakVinduRemoveAction => ({
  payload,
  type: RegistrationAction.TAK_VINDU_REMOVE
});

// BYGNINGSDETALJERING ACTIONS
export const updateBygningsdetaljer = (payload: UpdateBygningsdetaljerPayload): UpdateBygningsdetaljerAction => ({
  payload,
  type: RegistrationAction.UPDATE_BYGNINGSDETALJERING
});

// KONSTRUKSJONSTETTHET ACTIONS
export const updateKonstruksjonstetthet = (
  payload: UpdateKonstruksjonstetthetPayload
): UpdateKonstruksjonstetthetAction => ({
  payload,
  type: RegistrationAction.UPDATE_KONSTRUKSJONSTETTHET
});

// ENERGIBRUK ACTIONS
export const updateEnergibruk = (payload: UpdateEnergibrukPayload): UpdateEnergibrukAction => ({
  payload,
  type: RegistrationAction.UPDATE_ENERGIBRUK
});

export const updateEnergibrukUnit = (payload: UpdateEnergibrukUnitPayload): UpdateEnergibrukUnitAction => ({
  payload,
  type: RegistrationAction.UPDATE_ENERGIBRUK_UNIT
});

// TERRENGSKJERMING ACTIONS
export const updateTerrengskjerming = (payload: UpdateTerrengskjermingPayload): UpdateTerrengskjermingAction => ({
  payload,
  type: RegistrationAction.UPDATE_TERRENGSKJERMING
});

// DETAILING STEPS ACTIONS
export const updateDetailingSteps = (payload: UpdateDetailingStepsPayload): UpdateDetailingStepsAction => ({
  payload,
  type: RegistrationAction.UPDATE_DETAILING_STEPS
});

// TOGGLE ALL FLOORS HAVE THE SAME SHAPE
export const toggleAllFloorsHaveSameShape = (
  payload: ToggleAllFloorsSameShapePayload
): ToggleAllFloorsSameShapeAction => ({
  payload,
  type: RegistrationAction.TOGGLE_ALL_FLOORS_SAME_SHAPE
});

// TOGGLE ALL FLOORS HAVE THE SAME WALL CONSTRUCTION
export const toggleAllFloorsHaveSameWallConstr = (
  payload: ToggleAllFloorsSameWallConstrPayload
): ToggleAllFloorsSameWallConstrAction => ({
  payload,
  type: RegistrationAction.TOGGLE_ALL_FLOORS_SAME_WALL_CONSTR
});

// TOGGLE ALL WALLS AGAINST THE OPEN
export const toggleAllWallsAgainstTheOpen = (
  payload: ToggleAllWallsAgainstTheOpenPayload
): ToggleAllWallsAgainstTheOpenAction => ({
  payload,
  type: RegistrationAction.TOGGLE_ALL_WALLS_AGAINST_THE_OPEN
});

// GENERIC ACTION FOR UPDATING NESTED VALUE
export const updateRegistrationField = (payload: UpdateRegistrationFieldPayload): UpdateRegistrationFieldAction => ({
  payload,
  type: RegistrationAction.UPDATE_REGISTRATION_FIELD
});

// UPDATE TOTAL CALCULATED AREA FOR A FLOOR
export const updateCalculatedArea = (payload: UpdateCalculatedAreaPayload): UpdateCalculatedAreaAction => ({
  payload,
  type: RegistrationAction.UPDATE_CALCULATED_AREA
});

// UPDATE PARAMETERS
export const updateParameters = (payload: UpdateParametersPayload): UpdateParametersAction => ({
  payload,
  type: RegistrationAction.UPDATE_PARAMETERS
});
